import { QueryModule } from "@/data/invalidateQueries";
import { useAuthGuardedQuery } from "@/hooks/useAuthGuardedQuery";
import type { AppQueryOptions } from "@/types/react-query";

import { BizLocationApi } from "./bizLocation.api";
import type { BizLocationModels } from "./bizLocation.models";

export namespace BizLocationQueries {
  export const moduleName = QueryModule.BizLocation;

  export const keys = {
    all: [moduleName] as const,
    list: (limit: number, filter?: BizLocationModels.BizLocationPaginationFilterDto, page?: number, cursor?: string) =>
      [...keys.all, "/biz/location/list", limit, filter, page, cursor] as const,
  };

  /**
   * Query `useList`
   * @param { number } object.limit Query parameter. Items per response. Minimum: `1`. Maximum: `100`. Default: `10`
   * @param { BizLocationModels.BizLocationPaginationFilterDto } object.filter Query parameter
   * @param { number } object.page Query parameter. 1-indexed page number to begin from
   * @param { string } object.cursor Query parameter. ID of item to start after
   * @param { AppQueryOptions } options Query options
   * @returns { UseQueryResult<BizLocationModels.BizLocationPaginationResponseDto> }
   * @statusCodes [200]
   */
  export const useList = <TData>(
    {
      limit,
      filter,
      page,
      cursor,
    }: { limit: number; filter?: BizLocationModels.BizLocationPaginationFilterDto; page?: number; cursor?: string },
    options?: AppQueryOptions<typeof BizLocationApi.list, TData>,
  ) => {
    return useAuthGuardedQuery({
      queryKey: keys.list(limit, filter, page, cursor),
      queryFn: () => BizLocationApi.list(limit, filter, page, cursor),
      ...options,
    });
  };
}
